/**
 * Convert a message returned from server to a user friendly message
 * @param {string} message
 */
export default function convertSubmitOrderErrorMessage(
  message: string
): string {
  const commonError =
    'Unknown error, please contact the store owner for support.';

  if (!message?.startsWith || !message) return commonError;
  if (message.startsWith('[E902-E00003]')) {
    if (message.includes('cardNumber')) {
      return 'Invalid credit card number.';
    }
    if (message.includes('cardCode')) {
      return 'Invalid CVC number.';
    }

    return commonError;
  }

  if (message.startsWith('[E902-8] ')) {
    return message.substr('[E902-8] '.length);
  }
  return message;
}
